/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabBillPayment from './diaglab-bill-payment';
import DiaglabBillPaymentDetail from './diaglab-bill-payment-detail';
import DiaglabBillPaymentUpdate from './diaglab-bill-payment-update';
import DiaglabBillPaymentDeleteDialog from './diaglab-bill-payment-delete-dialog';

const DiaglabBillPaymentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabBillPayment />} />
    <Route path="new" element={<DiaglabBillPaymentUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabBillPaymentDetail />} />
      <Route path="edit" element={<DiaglabBillPaymentUpdate />} />
      <Route path="delete" element={<DiaglabBillPaymentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabBillPaymentRoutes;
